export * from "@gettactic/components/src/primitives/tabs";
